import Icon from '../components/Icon.vue'

Icon.register({
  'flag-checkered': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M243.2 189.9c24.2 6.7 47.6 16.4 73.6 22.2v68.2c-24.3-6.7-47.5-16.4-73.6-22.3v-68.1zM466.5 66.9c21.2-9.8 45.5 5.7 45.4 29v243.1c0 10.6-5.1 20.4-13.8 26.4-35.8 24.6-74.3 40.9-122.5 40.9-67.4 0-111.6-34.8-165.2-34.8-50.8 0-86.1 10-114.4 22.1v94.4c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-386.1c-14.5-10.1-24-26.9-24-45.9 0-31.7 26.3-57.3 58.3-56 28.5 1.2 51.8 24 53.6 52.4 0.5 8.4-0.8 16.3-3.6 23.6 20.7-7.6 43-12 68-12 67.4 0 111.7 34.8 165.2 34.8 40.5 0 82.7-16 117-31.9zM169.6 325.5v-71.3c-26.1 2.4-47.4 8.1-73.6 17.4v70.5c23.6-8.4 47.8-13.9 73.6-16.6zM464 191v-70.5c-21.3 8.9-46.6 17.7-73.6 22.5v71.9c-26 4.2-49.9 2.6-73.6-2.7v-68.4c-26.4-4.6-49.9-13.9-73.6-21.3v67.4c-25.2-7-46.6-9.4-73.6-5.7v-71.6c-23.5 2.2-40.4 9.8-73.6 22v70.5c29-10.7 51.2-17.8 73.6-20.9v70c32.8-3 53.9-0.6 73.6 3.8v68.5c26.3 4.6 49.7 13.9 73.6 21.3v-67.4c25.7 7.1 46.6 9.3 73.6 5.6v71.6c25.1-2.4 48.5-11 73.6-27.1v-70.5c-22.2 14.2-48.8 22.6-73.6 26v-71.1c27.3-4.4 50-14.1 73.6-23.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/flag-checkered.js
// module id = 1358
// module chunks = 0